import { matchSorter } from 'match-sorter';
import { useContext } from 'react';
import AppContext from '../../../common/containers/AppContext';

export default function useFindFamilies(searchText) {
    const { families } = useContext(AppContext);

    const filteredFamilies = families ? matchSorter(families, searchText, { keys: ['label'] }) : [];
    return [filteredFamilies, false, false];
}
